export const environment = {
  production: true,
  url: 'https://intranet-api.lempls.com/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts